import { CreateConferenceNote } from 'domain/usecases/conferenceNote/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteCreateConferenceNote implements CreateConferenceNote {
  private readonly url: string;

  private readonly httpClient: HttpClient<CreateConferenceNote.Model>;

  constructor(url: string, httpClient: HttpClient<CreateConferenceNote.Model>) {
    this.url = url;
    this.httpClient = httpClient;
  }

  create = async (
    params: CreateConferenceNote.Params,
  ): Promise<CreateConferenceNote.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.short}/notes`,
      method: 'post',
      body: params.body,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.noContent:
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      default:
        throw new UnexpectedError();
    }
  };
}
